import { connect } from 'react-redux';

import ProgramSlider from './programslider';
import { setDetailPanelTarget } from '@store/actions/ux';
import { requestProgramDetails } from '@search/store/actions/requests';

const mapStateToProps = state => ({
  channels: state.channels,
});

const mapDispatchToProps = dispatch => ({
  openDetailPanel: (type, id, pid) => {
    dispatch(setDetailPanelTarget(id));
    dispatch(requestProgramDetails(type, id, pid));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgramSlider);
